"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    storage = {},
    getWindow = function getWindow() {
  return "undefined" == typeof window ? {
    localStorage: {
      setItem: function c(a, b) {
        return storage[a] = b;
      },
      getItem: function b(a) {
        return storage[a] || null;
      },
      removeItem: function b(a) {
        return delete storage[a];
      }
    }
  } : window;
},
    StorageService =
/*#__PURE__*/
function () {
  function a() {
    (0, _classCallCheck2.default)(this, a);
  }

  return (0, _createClass2.default)(a, null, [{
    key: "setAppKey",
    value: function b(a) {
      getWindow().localStorage.setItem("appkey", a);
    }
  }, {
    key: "getAppKey",
    value: function a() {
      return getWindow().localStorage.getItem("appkey");
    }
  }, {
    key: "removeAppKey",
    value: function a() {
      return getWindow().localStorage.removeItem("appkey");
    }
  }, {
    key: "setNonce",
    value: function b(a) {
      getWindow().localStorage.setItem("nonce", a);
    }
  }, {
    key: "getNonce",
    value: function a() {
      return getWindow().localStorage.getItem("nonce");
    }
  }, {
    key: "removeNonce",
    value: function a() {
      return getWindow().localStorage.removeItem("nonce");
    }
  }]), a;
}();

exports.default = StorageService;